/**
 * ReleaseReservationDialog.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Confirmação de "Liberar horário" de uma reserva, com o toggle "Avisar o
 * paciente pelo WhatsApp" (só para horário futuro). Recebe o estado de
 * useReservationRelease; usado no painel da agenda e na aba Reservas do Início.
 *
 * @module ReleaseReservationDialog
 */

import React from 'react';
import ConfirmDialog from '../../../../../components/ConfirmDialog/ConfirmDialog';
import styles from './ReserveSlotDrawer.module.css';

/**
 * @param {Object} props
 * @param {Object} props.release - retorno de useReservationRelease
 */
export default function ReleaseReservationDialog({ release }) {
  return (
    <ConfirmDialog
      isOpen={release.confirmOpen}
      title="Liberar horário"
      message="A reserva é cancelada, o horário volta a ficar livre na agenda e o link de cadastro enviado ao paciente deixa de funcionar."
      confirmLabel="Liberar"
      cancelLabel="Voltar"
      variant="danger"
      onConfirm={release.release}
      onCancel={release.closeConfirm}
      loading={release.isBusy}
    >
      {release.canNotify && (
        <div className={styles.notifyRow}>
          <span className={styles.notifyLabel}>
            Avisar o paciente pelo WhatsApp
            <span className={styles.notifyHint}>
              {release.ownNumber ? 'Sai pelo WhatsApp da clínica.' : 'Abre o WhatsApp com a mensagem pronta.'}
            </span>
          </span>
          <label className={styles.toggleWrapper}>
            <input
              type="checkbox"
              className={styles.toggleInput}
              checked={release.notifyPatient}
              onChange={(e) => release.setNotifyPatient(e.target.checked)}
              aria-label="Avisar o paciente pelo WhatsApp"
            />
            <span className={styles.toggleSlider} />
          </label>
        </div>
      )}
    </ConfirmDialog>
  );
}
